import React from 'react';
import { t } from 'i18next';
import { CheckIcon } from 'components/icons/CheckIcon';

export default function FulfillmentType({
  id,
  title,
  description,
  onOptionChange,
  value,
  disabled
}) {
  const selected = value === id;

  return (
    <label
      className={`relative flex rounded-lg bg-white p-4 ${!disabled ? 'shadow border-2 cursor-pointer hover:border-[#2e8634]' : 'border'} ${selected ? 'border-[#2e8634] border-solid border-2' : 'border-[#dddddd]'}`}
      id={id}>
      <input
        type="radio"
        name="fulfillmentType"
        readOnly
        value={value}
        className="sr-only"
        required
        disabled={disabled}
        onChange={() => onOptionChange(id)}
      />
      <span className="flex flex-1">
        <span className="flex flex-col">
          <span
            className={`block text-sm font-medium ${disabled && 'text-gray-400'}`}>
            {title}
          </span>
          <span
            className={`mt-1 flex items-center text-sm ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            {disabled
              ? t(
                  'steps.deliveryMoment.fulfillmentType.delivery.within_service_area'
                )
              : description}
          </span>
        </span>
      </span>
      {selected && <CheckIcon className="flex! items-start!" />}
      <span
        className="spanWithBorder pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent"
        aria-hidden="true"></span>
    </label>
  );
}
